import { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { AppHeader } from '@/components/AppHeader';
import { AppFooter } from '@/components/AppFooter';
import { FirstTimeLocationModal } from '@/components/FirstTimeLocationModal';
import { useLocationStore } from '@/stores/location.store';
import { usePageTracking } from '@/services/analytics';

const { Content } = Layout;

export const MainLayout = () => {
  // Analytics: Track page views on route changes (Story 11.10)
  usePageTracking();
  const { hasPromptedUser, selectedCity } = useLocationStore();
  const [showLocationModal, setShowLocationModal] = useState(false);

  // Show location modal on initial load for first-time users
  useEffect(() => {
    if (!hasPromptedUser && !selectedCity) {
      setShowLocationModal(true);
    }
  }, [hasPromptedUser, selectedCity]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader />
      <Content style={{ padding: '24px 50px' }}>
        <Outlet />
      </Content>
      <AppFooter />

      {/* First-time location modal */}
      <FirstTimeLocationModal
        open={showLocationModal}
        onComplete={() => setShowLocationModal(false)}
      />
    </Layout>
  );
};
